export const SIMULATE_COMPLETE_PAYMENT_START = 'SIMULATE_COMPLETE_PAYMENT_START';
export const SIMULATE_COMPLETE_PAYMENT_SUCCESS = 'SIMULATE_COMPLETE_PAYMENT_SUCCESS';
export const SIMULATE_COMPLETE_PAYMENT_FAIL = 'SIMULATE_COMPLETE_PAYMENT_FAIL';

export const SIMULATE_ADD_PAYMENT_METHOD_START = 'SIMULATE_ADD_PAYMENT_METHOD_START';
export const SIMULATE_ADD_PAYMENT_METHOD_SUCCESS = 'SIMULATE_ADD_PAYMENT_METHOD_SUCCESS';
export const SIMULATE_ADD_PAYMENT_METHOD_FAIL = 'SIMULATE_ADD_PAYMENT_METHOD_FAIL';

export const THREE_DS_TIMEOUT = 'THREE_DS_TIMEOUT';
